import React from "react";

export default React.createContext({
    isAuthenticated:false,
    setIsAuthenticated:(value) => {},

    username: "",
    setUsername: (value) => {},

    role: "",
    setRole: (value) => {},

    firstname: "",
    setFirstname: (value) => {},

    lastname: "",
    setLasname: (value) => {},
})